module.exports = __webpack_public_path__ + "static/media/view_action.27b98b92.svg";